var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"items":_vm.headerButtons,"show-back-button":true,"title":_vm.title},on:{"back":function($event){return _vm.$router.push({ name: 'projectDataExplorer' })},"open-editor":_vm.openEditor}}),(_vm.ready && _vm.dataStructure !== [])?_c('Preview',{attrs:{"data-structure":_vm.dataStructure}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }